import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const BillingDetail = React.lazy(() =>
    import('../BillingDetail')
);
const billingDetailRoutesRegistry = [
    {
        path: PAGE_URL.BILLING_DETAIL_PAGE,
        element: <BillingDetail />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default billingDetailRoutesRegistry;
